
<div class="watchlist">
  <ftu-block
    dismiss-key="watchlist"
    icon="visibility"
    title="This is your Watchlist"
    description="With your Watchlist, you can get daily updates on cards you care about. You can add any card to your watchlist from this page or the card's profile. You can also set up price alerts for when the price goes above or below a specific price point."
  />

  <page-header title="Watchlist">
    <template #actions>
      <icon-button
        v-if="showAdd"
        icon="add_circle"
        @click="addModalOpen = true"
      />
    </template>
  </page-header>

  <empty-state
    v-if="showEmptyState"
    icon="style"
    title="You aren't watching any cards!"
    description="Cards can be added by clicking the Add button above"
  />

  <template v-else>
    <align flex collapse-end direction="flex-start">
      <shared-filters
        :filters.sync="filters"
        :query.sync="query"
        :properties="defaultFilters"
        @clear="clearFilters"
      />

      <direction-sort-options
        :sort.sync="sort"
        :direction.sync="direction"
        :options="sortOptions"
      />
    </align>

    <filter-results
      :is-filtering="hasFilters"
      :filters="filters"
      @clear="clearFilters"
    />

    <div class="results">
      <empty-state
        v-if="showEmptyFilterState"
        icon="search_off"
        title="There are no results with your filters"
        description="Try adjusting your filters"
      />

      <template>
        <div class="list">
          <card-list-item
            v-for="card in watchlistItems"
            :key="card.id"
            :to="{ path: '/watchlist', query: { ...$route.query, cardId: card.cardId, profile: 'watchlist' } }"
            :card="card"
            :fields="itemFields"
            as="router-link"
          >
            <icon-button
              tooltip="Setup price alerts"
              :class="['alert-icon', getAlertIcon(card)]"
              :icon="getAlertIcon(card)"
              @click="setupAlerts(card)"
            />
          </card-list-item>
        </div>

        <infinite-scroll
          :loading="loading"
          :has-more-data="hasMoreData"
          @load="nextPage"
        />
      </template>
    </div>
  </template>

  <watchlist-add-modal
    :open="addModalOpen"
    @close="addModalOpen = false"
  />
</div>
